// Input component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import validator from 'validator'

import IconButton from '../../common/icon_button/icon_button.jsx'
import Util from '../../../lib/util.jsx'
import currency from '../../../lib/currency.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import ThemeIconButton from '../../../theme/common/icon_button/icon_button.jsx'

class Input extends Component {
  constructor (props) {
    super(props)

    this._inputClassName = 'form-input'

    this.state = {
      value: props.value,
      bLabel: !!(
        props.value !== '' &&
        props.value !== undefined &&
        props.value !== null
      ),
      error: false,
      typePassword: 'password'
    }

    this._references = {
      input: React.createRef()
    }
  }

  static get propTypes () {
    return {
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      type: PropTypes.string,
      maxLength: PropTypes.number,
      size: PropTypes.number,
      value: PropTypes.any,
      validations: PropTypes.array,
      label: PropTypes.string,
      prefix: PropTypes.string,
      prefixIcon: PropTypes.string,
      suffix: PropTypes.string,
      suffixIcon: PropTypes.string,
      styleDotted: PropTypes.bool,
      autoComplete: PropTypes.string,
      onFocus: PropTypes.func,
      onClickPrefix: PropTypes.func,
      onClickSuffix: PropTypes.func,
      prefixCustom: PropTypes.bool,
      disabled: PropTypes.bool,
      onBlur: PropTypes.func,
      errorMsg: PropTypes.string,
      autoFocus: PropTypes.bool,
      showPlaceholder: PropTypes.bool,
      selectValue: PropTypes.bool,
      onChange: PropTypes.func,
      getValue: PropTypes.func,
      multilingual: PropTypes.bool,
      showDecimal: PropTypes.bool,
      tooltip: PropTypes.string,
      tooltipPosition: PropTypes.oneOf(['right', 'left', 'bottom', 'top']),
      tooltipData: PropTypes.object,
      showCurrency: PropTypes.bool,
      prefixCurrency: PropTypes.string,
      allowShowPassword: PropTypes.bool,
      sanitizers: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      name: '',
      className: '',
      type: 'text',
      value: '',
      validations: [],
      label: '',
      prefix: '',
      prefixIcon: '',
      suffix: '',
      suffixIcon: '',
      styleDotted: false,
      autoComplete: 'off',
      onFocus: null,
      onClickPrefix: null,
      onClickSuffix: null,
      prefixCustom: false,
      disabled: false,
      onBlur: null,
      error: false,
      errorMsg: '',
      autoFocus: false,
      showPlaceholder: true,
      selectValue: false,
      onChange: null,
      getValue: null,
      multilingual: true,
      showDecimal: false,
      tooltip: '',
      tooltipPosition: 'top',
      tooltipData: {},
      showCurrency: false,
      prefixCurrency: '',
      allowShowPassword: false,
      sanitizers: []
    }
  }

  componentDidUpdate () {
    this._focusInput()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this.setState({
      value: nextProps.value,
      bLabel: !!nextProps.value,
      error: nextProps.error
    })
  }

  render () {
    const {
      allowShowPassword,
      prefixIcon,
      prefix,
      suffixIcon,
      type,
      name,
      size,
      suffix,
      maxLength,
      styleDotted,
      label,
      className,
      error,
      errorMsg,
      prefixCustom,
      disabled,
      autoComplete,
      autoFocus,
      selectValue,
      showPlaceholder,
      validations,
      onClickPrefix,
      onClickSuffix,
      getValue,
      multilingual,
      onBlur,
      showDecimal, // eslint-disable-line
      tooltip,
      tooltipPosition,
      tooltipData,
      prefixCurrency,
      showCurrency: _showCurrency, // eslint-disable-line
      sanitizers,
      ...others
    } = this.props

    const prefixIconClass = `icon icon-${prefixIcon} normal`
    let placeholder = ''

    if (
      label &&
      this.state.bLabel &&
      this.state.value !== '' &&
      this.state.value !== undefined &&
      this.state.value !== null &&
      showPlaceholder
    ) {
      placeholder = label
    }

    let showError = false
    if (this.state.error && errorMsg) {
      showError = true
    }

    let isShowCurrency = false
    if (currency.getCurrency() === 'USD') {
      isShowCurrency = true
    }

    let tooltipPositionClass = ''
    if (tooltipPosition === 'top') {
      tooltipPositionClass = 'tiptop'
    }

    const _className = classnames(
      this._inputClassName,
      {
        has_error: this.state.error,
        'form-input_prefix': prefix,
        'form-input_prefixicon': prefixIcon || prefixCurrency,
        'form-input_suffix': suffix,
        'form-input_suffixicon': suffixIcon,
        'form-input_prefixcustom': prefixCustom,
        'form-input_disabled': disabled
      },
      className,
      tooltipPositionClass
    )
    const _inputClass = classnames('input', {
      input_dotted: styleDotted
    })
    const prefixValue = multilingual ? (
      <span className='input-prefix-label'>
        <IntlMessage ident={prefix} />
      </span>
    ) : (
      <span className='input-prefix-label'>{prefix} </span>
    )

    const inputType = type === 'password' ? this.state.typePassword : type

    return (
      <div className={_className}>
        {prefix ? prefixValue : null}
        {prefixIcon ? (
          <div
            className='input-prefix-icon'
            onClick={this._onClickPrefix.bind(this)}
          >
            <span className={prefixIconClass} />
          </div>
        ) : null}
        {prefixCurrency ? (
          <div
            className='input-prefix-icon'
            onClick={this._onClickPrefix.bind(this)}
          >
            <span className={`currencylabel${isShowCurrency ? ' active' : ''}`}>
              {prefixCurrency}
            </span>
          </div>
        ) : null}
        {prefixCustom ? (
          <IconButton
            icon='form-input-delete'
            type='primary'
            canHover
            className='input-prefix-custom'
            onClick={this._onClickPrefix.bind(this)}
          />
        ) : null}
        <input
          className={_inputClass}
          ref={this._references.input}
          {...others}
          type={inputType}
          name={name}
          value={this._formatValue(this.state.value)}
          size={size}
          disabled={disabled}
          maxLength={maxLength}
          placeholder={label ? IntlUtil.convertMessage(label) : ''}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          onChange={this._onChange.bind(this)}
          onFocus={
            selectValue
              ? this._onSelectFocus.bind(this)
              : this._onFocus.bind(this)
          }
          onBlur={this._onBlur.bind(this)}
        />
        {showError ? (
          <span className='input-error-label'>
            <i className='icon icon-form-inputerror' />
            {errorMsg}
          </span>
        ) : null}
        {placeholder ? (
          <span className='input-placeholder-label'>
            <IntlMessage ident={placeholder} />
          </span>
        ) : null}
        {suffixIcon ? (
          <IconButton
            icon={suffixIcon}
            size='normal'
            canHover
            className='input-suffix-icon'
            onClick={this._onClickSuffix.bind(this)}
            tooltip={this.props.tooltip}
            tooltipPosition={this.props.tooltipPosition}
          />
        ) : null}

        {suffix ? (
          <span className='input-suffix-label'>
            <IntlMessage ident={suffix} />
          </span>
        ) : null}

        {type === 'password' && this.props.allowShowPassword && (
          <ThemeIconButton
            className='input-suffix-icon'
            size='normal'
            icon='eye'
            type='secondary'
            canHover
            onClick={this._onChangePasswordType.bind(this, inputType)}
          />
        )}
      </div>
    )
  }

  /* Public Functions */
  getValue () {
    return this.sanitize(this.state.value)
  }

  getValueAsWebsite () {
    let val = this.getValue()
    if (
      val &&
      val.indexOf('http://') === -1 &&
      val.indexOf('https://') === -1
    ) {
      val = `http://${val}`
    }

    return val
  }

  validate () {
    const validations = this.props.validations
    if (validations !== undefined && validations.length > 0) {
      for (let i = 0; i < validations.length; i++) {
        if (!this._validateField(validations[i])) {
          this.setState({ error: true })
          return false
        }
      }
    }

    return true
  }

  sanitize (value) {
    const sanitizers = this.props.sanitizers

    sanitizers.forEach(sanitizer => {
      value = validator[sanitizer](value)
    })

    return value
  }

  clearError () {
    this.setState({ error: false })

    return this.state.error
  }

  showError () {
    this.setState({ error: true })
    return this.state.error
  }

  clear () {
    this.setState({ error: false, value: '' })
  }

  /* Private Functions */
  _formatValue (value) {
    return value
  }

  _validateField (validType) {
    const val = this.getValue()

    switch (validType) {
      case 'required':
        return val ? !validator.isEmpty(val.toString()) : false
      case 'email':
        return validator.isEmail(val)
      case 'positive':
        return this._isPostiveNumber(val)
      case 'url':
        return validator.isAlphanumeric(val)
      case 'username':
        return validator.isAlphanumeric(val)
      case 'password':
        return !(validator.isEmpty(val) || !Util.isValidPassword(val))
      case 'phone':
        return validator.isMobilePhone(val)
      case 'website':
        return validator.isURL(this.getValueAsWebsite())
      case 'price':
        return this._validatePrice(val)
      case 'intlphone':
        return Util.isValidPhoneNumber(val)
      default:
        return true
    }
  }

  _validatePrice (value) {
    if (!value) return false

    const r = /^[0-9,]+$/.test(value)
    if (!r || this._getFloatFromMoney(value) < 0) {
      return false
    }
    return true
  }

  _isPostiveNumber (value) {
    const floatVal = parseFloat(value)

    return !isNaN(floatVal) && floatVal > 0
  }

  _getFloatFromMoney (val) {
    val = val.toString()
    val = val.replace(/,/g, '~')
    val = val.replace(/\./g, '')
    val = val.replace(/~/g, '.')

    val = parseFloat(val)

    if (isNaN(val)) {
      return 0
    }

    return val
  }

  focus () {
    if (this._references.input.current) {
      this._references.input.current.focus()
    }
  }

  /* Event handlers */
  _onChange (event) {
    const { onChange, maxLength } = this.props
    const valueFromEvent = event.target.value

    const haveToTrim = maxLength && event.target.value.length > maxLength
    const value = haveToTrim
      ? valueFromEvent.substr(0, maxLength)
      : valueFromEvent

    if (value) {
      this.setState({
        value: value,
        error: false,
        bLabel: true
      })
    } else {
      this.setState({ value: value })
    }

    if (onChange) {
      onChange(value, event)
    }
  }

  _onChangePasswordType (type) {
    if (type === 'password') {
      this.setState({ typePassword: 'text' })
    } else if (type === 'text') {
      this.setState({ typePassword: 'password' })
    }
  }

  _onClickSuffix (ev) {
    ev.preventDefault()

    if (this.props.onClickSuffix) {
      this.props.onClickSuffix(ev)
    }
  }

  _onClickPrefix (ev) {
    ev.preventDefault()

    if (this.props.onClickPrefix) {
      this.props.onClickPrefix(ev)
    }
  }

  _onFocus (ev) {
    ev.preventDefault()

    // to set the cursor pointer to the end
    var value = ev.target.value
    ev.target.value = ''
    ev.target.value = value

    if (this.state.value === 0 || this.state.value === '0') {
      ev.target.select()
    }

    if (this.props.onFocus) {
      this.props.onFocus(ev)
    }
  }

  _onSelectFocus (ev) {
    ev.preventDefault()
    ev.target.select()

    if (this.props.onFocus) {
      this.props.onFocus(ev)
    }
  }

  _onBlur (ev) {
    ev.preventDefault()

    var value = ev.target.value
    if (value !== this.state.value) {
      this.setState({ value: value })

      if (this.props.onChange) {
        this.props.onChange(value, ev)
      }
    }

    if (this.props.onBlur) {
      this.props.onBlur(ev)
    }
  }

  _focusInput () {
    if (this.props.autoFocus) {
      this.focus()
    }
  }
}

export default Input
